import React from 'react';
import { FuelTooltip, FuelTypography } from '@frete.com/fuel-react';
import {
  FuelFlex,
  FuelOriginAndDestination,
} from '@frete.com/fuel-station-react';
import ShieldLock from '@assets/svg/shieldLock.svg';
import { TruckerLastLocationProps } from './TruckerLastLocationTypes';
import * as Styled from './TruckerLastLocation.Styles';
import TruckerAvatar from '../TruckerAvatar/TruckerAvatar';

function TruckerLastLocation({
  avatar,
  name,
  notification = { isShow: false, total: 0 },
  depositFee,
  origin,
  destination,
  hasOpacity,
}: TruckerLastLocationProps) {
  function handlePrintTruckerName() {
    return (
      <FuelFlex defaultProps={{ gap: 'km1' }}>
        <FuelTypography
          tag="p"
          size="caption"
          color="neutral-strong"
          weight="medium"
        >
          {name?.toLowerCase()}
        </FuelTypography>
        {depositFee?.tagLabel && (
          <FuelTooltip
            placement="bottom"
            label="Esse motorista pagou o Frete Seguro"
            content="Garantias para o motorista e cobertura em caso de roubo da carga."
            size="sm"
          >
            <Styled.ShieldLockIcon src={ShieldLock} data-testid="shield-icon" />
          </FuelTooltip>
        )}
      </FuelFlex>
    );
  }

  function handlePrintWaypoints() {
    return (
      <Styled.WrapperOriginAndDestination>
        <FuelOriginAndDestination
          origin={origin}
          destination={destination}
          isLarge={false}
          nowrap
        />
      </Styled.WrapperOriginAndDestination>
    );
  }

  return (
    <Styled.Content>
      <FuelFlex
        defaultProps={{ alignItems: 'center', flexWrap: 'wrap', gap: 'km3' }}
      >
        <TruckerAvatar
          name={name}
          photo={avatar}
          notification={notification}
          hasOpacity={hasOpacity}
        />
        <Styled.WrapperAlignRigth>
          {handlePrintTruckerName()}
          {handlePrintWaypoints()}
        </Styled.WrapperAlignRigth>
      </FuelFlex>
    </Styled.Content>
  );
}

export default TruckerLastLocation;
